import styled from 'styled-components';

export const FollowWrap = styled.div`
  ul {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px 16px 0;
    height: 765px;
    overflow: scroll;
  }
  h1 {
    position: absolute;
    top: 16px;
    left: 45px;
  }
`;
